
import apiClient, { ApiResponse } from '../../apiClient';
import { ListUserActivityResponse, UserActivitySummary } from './activity.model';

const base = '/api/audit';

export function listUserActivity(): Promise<ApiResponse<ListUserActivityResponse>> {
  return apiClient.get<ListUserActivityResponse>(
    `${base}/user-activity`,
    {
      headers: { Accept: 'text/plain' }
    } as any
  );
}

export function listUserActivityStatistics(): Promise<ApiResponse<UserActivitySummary>> {
  return apiClient.get<UserActivitySummary>(
    `${base}/user-activity/statistics`,
    {
      headers: { Accept: 'text/plain' }
    } as any
  );
}

export function userActivityLogout(): Promise<ApiResponse<any>> {
  return apiClient.post<any>(
    `${base}/user-activity/logout`,
    {
      headers: { Accept: 'text/plain' }
    } as any
  );
}